const CaretDown = ({ className, fillColor = "#000" }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    version="1.1"
    className={className}>
    <defs>
      <filter colorInterpolationFilters="auto" id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.109804 0 0 0 0 0.105882 0 0 0 0 0.129412 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
    </defs>
    <g
      id="icon/downarrow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="down-arrow">
        <g transform="translate(8.000000, 12.000000)">
          <polygon
            id="Path"
            fill={fillColor}
            fillRule="nonzero"
            points="0 0 8.0000375 8 16 0"></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export default CaretDown;
